"use client";

import { type PropsWithChildren, useEffect, useRef, useState } from "react";
import { BackToTopContext } from "~/app/[lang]/overlay/BackToTopContext";

export function BackToTopProvider(props: PropsWithChildren) {
	const topRef = useRef<HTMLDivElement>(null);
	const bottomRef = useRef<HTMLDivElement>(null);
	const [show, setShow] = useState(false);

	useEffect(() => {
		const topElement = topRef.current;
		const bottomElement = bottomRef.current;

		const observer = new IntersectionObserver((entries) => {
			setShow(entries.every((entry) => !entry.isIntersecting));
		});

		if (topElement) observer.observe(topElement);
		if (bottomElement) observer.observe(bottomElement);

		return () => {
			if (topElement) observer.unobserve(topElement);
			if (bottomElement) observer.unobserve(bottomElement);
		};
	}, []);

	return (
		<BackToTopContext.Provider value={{ show }}>
			<div ref={topRef} className="-z-3 absolute top-0 right-0 left-0 h-[75vh]" />

			<div ref={bottomRef} className="-z-3 absolute right-0 bottom-0 left-0 h-[5vh]" />

			{props.children}
		</BackToTopContext.Provider>
	);
}
